import { getCurrentSession } from '../../lib/authentication';

export const fetch = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      let { idToken } = session;

      return apigClient
        .adminInvitesGet(params, {}, {
            headers: {
                Authorization: idToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};


export const create = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      let { idToken } = session;

      return apigClient
        .adminInvitesCreate(params, {}, {
            headers: {
                Authorization: idToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};

export const remove = (params = {}) => {
  return Promise.all([getCurrentSession()])
    .then(results => {
      const [session] = results;

      let { idToken } = session;

      return apigClient
        .adminInvitesRemove(params, {}, {
            headers: {
                Authorization: idToken
            }
        })
        .then(resp => resp.data)
        .catch(e => {
            throw e.data;
        });
    });
};
